import React from "react";
import icons from "../utils/icons";
import { NavLink, useNavigate, Link } from "react-router-dom";
import NavLinks from "./NavLinks";

export default function Footer() {
  const { Logo } = icons();
  const navigate = useNavigate();
  const { footerMenu } = NavLinks();
  const GoTOP = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <div className="footer-container">
      <div className="footer-grid">
        {/* Brand Column */}
        <div className="footer-col">
          <NavLink to="/" className="logo" onClick={GoTOP}>
            <Logo />
          </NavLink>
          <p>
            Your trusted partner to on-ramp and <br /> off-ramp Crypto Currency.
            Secure, fast, and reliable.
          </p>
        </div>

        {/* Links Columns */}
        {footerMenu.map((section, index) => (
          <div className="footer-col" key={index}>
            <h3>{section.title}</h3>
            {section.menu.map((menu, i) => (
              <NavLink key={i} to={menu.link} onClick={GoTOP}>
                {menu.title}
              </NavLink>
            ))}
          </div>
        ))}

        {/* Contact Column */}
        <div className="footer-col">
          <h3>Contact Us</h3>
          <div className="flex align-items-start gap-2">
            <i className="pi pi-map-marker mt-1 text-primary" />
            <p>330 5 Ave SW, Suite 1800<br />Calgary, AB T2P 0L4</p>
          </div>
          <div className="flex align-items-center gap-2">
            <i className="pi pi-envelope text-primary" />
            <a href="mailto:support@tinbox.app">support@tinbox.app</a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div>© {new Date().getFullYear()} Tinbox. All rights reserved.</div>
        <div className="legal-links">
          <NavLink to="/privacy-policy" onClick={GoTOP}>Privacy Policy</NavLink>
          <NavLink to="/terms&Conditions" onClick={GoTOP}>Terms & Conditions</NavLink>
        </div>
      </div>
    </div>
  );
}
